import { fetchOrderItemFlightDetails } from 'actions/OrderActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useStableObjectReference from 'hooks/useStableObjectReference'
import { useEffect } from 'react'

const EmptyState = {
  flight: undefined,
  fetching: true,
  error: undefined,
} as const

function useOrderFlightDetails(
  orderId: string | undefined,
  _itemIds: Array<string | undefined>,
  key?: string,
): Array<{ flightDetails: App.FlightOrderItemDetails | undefined, fetching: boolean | undefined, error: any }> {
  const dispatch = useAppDispatch()

  const itemIds = useStableObjectReference(_itemIds)

  useEffect(() => {
    if (orderId) {
      itemIds.forEach(itemId => {
        if (itemId) {
          dispatch(fetchOrderItemFlightDetails(orderId, itemId, Boolean(key)))
        }
      })
    }
  }, [orderId, itemIds, key, dispatch])

  const detailsState = useAppSelector(state => state.orders.flightDetails)

  return itemIds.map(itemId => {
    const itemDetails = detailsState[itemId as string] ?? EmptyState

    return {
      flightDetails: itemDetails.flight,
      fetching: itemDetails.fetching,
      error: itemDetails.error,
    }
  })
}

export default useOrderFlightDetails
